import { CentsPalette } from "../../../../utils/colors";
import { CustomFilledButton } from "../../common/buttons/CustomFilledButton";
import React from "react";

export function FieldCancelButton({ onClick, disabled }: { onClick: () => void, disabled?: boolean }): JSX.Element {
  return (<CustomFilledButton
    onClick={onClick}
    className="h-10 !w-10 !px-0 !bg-red-500 focus:outline-none"
    disabled={disabled}
  >
    <svg className="h-3.5 w-3.5" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L36 36M36 4L4 36" stroke={CentsPalette.cents_white} strokeLinecap="round" strokeLinejoin="round" strokeWidth="5" />
    </svg>
  </CustomFilledButton>)
}
